import type { ICustomControlProcedureReadProps } from '../../interfaces/';
import { translateKey } from '../../../../../translate';
import { FormParagraph } from '../../../../elements/common';
import { FormGroup } from '../../../../elements/forms/FormGroup';
import { FormLabel } from '../../../../elements/forms/FormLabel';
import { HorizontalFormGroupRead } from '../../../../elements/forms/horizontalFormGroupRead/HorizontalFormGroupRead';
import { InputContainer } from '../../../../elements/forms/InputContainer';
import { ProcedureAssetThumbnails } from '../../../episodes/common';

export function TiecgV1ProcedureSummary(props: ICustomControlProcedureReadProps) {
    if (!props.procedure || !props.procedure.customControlData) {
        return null;
    }

    return (
        <>
            {props.procedure.assets && props.procedure.assets.length > 0 && (
                <FormGroup>
                    <FormLabel>{translateKey('request.attachment')}: </FormLabel>
                    <ProcedureAssetThumbnails
                        assets={props.procedure.assets}
                        procedureId={props.procedure.id}
                    />
                </FormGroup>
            )}

            {props.procedure.customControlData.bloeddruk_systolisch && (
                <HorizontalFormGroupRead>
                    <FormLabel>Bloeddruk systolisch</FormLabel>
                    <InputContainer>
                        <FormParagraph>
                            {props.procedure.customControlData.bloeddruk_systolisch + ' mmHg'}
                        </FormParagraph>
                    </InputContainer>
                </HorizontalFormGroupRead>
            )}
            {props.procedure.customControlData.bloeddruk_diastolisch && (
                <HorizontalFormGroupRead>
                    <FormLabel>Bloeddruk diastolisch</FormLabel>
                    <InputContainer>
                        <FormParagraph>
                            {props.procedure.customControlData.bloeddruk_diastolisch + ' mmHg'}
                        </FormParagraph>
                    </InputContainer>
                </HorizontalFormGroupRead>
            )}
        </>
    );
}
